const RESERVED_ATTRIBUTE_NAMES = [
    "ID",
    "Last Updated On",
    "Last Updated By",
    "Created On",
    "Created By",
];

const NORMALIZED_RESERVED_NAMES = new Set(
    RESERVED_ATTRIBUTE_NAMES.map((name) => normalizeAttributeName(name))
);

export function normalizeAttributeName(name = "") {
    return name.toLowerCase().replace(/[^a-z0-9]/g, "").trim();
}

export function isReservedAttributeName(name = "") {
    return NORMALIZED_RESERVED_NAMES.has(normalizeAttributeName(name));
}

export { RESERVED_ATTRIBUTE_NAMES };
